import { ArticlePollType } from "@olagg/db-types"
import { AdminArticlePollsEndpoints } from "../endpoints/adminEndpoints"
import { fetcher } from "../fetcher"
import { useToast } from "@chakra-ui/react"
import { useQ } from "./useQ"
import { useState } from "react"

export const useAdminArticlePolls = (filter: { page: number, limit: number, slug?: string, source?: string }) => {
  const toast = useToast();
  const [articlePoll, setArticlePoll] = useState<ArticlePollType>();

  const response = useQ<{ articlePolls: ArticlePollType[], meta: { count: number } }>(
    AdminArticlePollsEndpoints.all(filter)
  );

  const updateArticlePoll = async (id: number, data: Partial<ArticlePollType>, callback?: () => void) => {
    return await fetcher(AdminArticlePollsEndpoints.update(id, data))
      .then((res: any) => {
        toast({
          title: 'Encuestas de Novedades',
          colorScheme: 'olaggPink',
          status: 'success',
          description: 'Encuesta actualizada. Queda congelada: el recálculo ya no la toca.',
          position: 'bottom-right'
        });
        if (res?.articlePoll) setArticlePoll(res.articlePoll);
        response.mutate();
        callback?.();
      })
      .catch((error: any) => {
        const reason = error?.errors || error?.error;

        toast({
          title: 'Error',
          colorScheme: 'olaggYellow',
          status: 'error',
          description: reason === 'unauthorized'
            ? 'Tu rol no tiene permiso sobre el módulo "Encuestas de Novedades". Revisalo en Permisos → Roles y permisos.'
            : reason,
          position: 'bottom-right'
        });
      })
  }

  const find = (id: number) => {
    fetcher(AdminArticlePollsEndpoints.find(id))
      .then(res => setArticlePoll(res.articlePoll))
  }

  return {
    ...response,
    articlePoll,
    find,
    updateArticlePoll,
  }
}
